import { BorrowerType } from 'enums/BorrowerType';
import BaseSettingsApi, { IBasePortalSettings } from 'api/digifi/base/BaseSettingsApi';

export const DEFAULT_BORROWER_TYPES = [BorrowerType.Person, BorrowerType.Company];

interface IBorrowerPortalConfiguration {
  borrowerLockPeriodDays: number;
}

export interface IBorrowerPortalSettings extends IBasePortalSettings {
  portalConfiguration: IBorrowerPortalConfiguration;
  borrowerTypes: BorrowerType[];
}

export default class BorrowerSettingsApi extends BaseSettingsApi<IBorrowerPortalSettings> {}
